import AxiosDefaultRequestConfig from './AxiosDefaultRequestConfig';
import SubscriptionValidResult from '@/SubscriptionValidResult';
import AxiosPostProcessor from './AxiosPostProcessor';
import Axios, { AxiosResponse } from 'axios';
import User from '@/User';
import QueryStringUtility from './QueryStringUtility';
import GoogleLoginResponse from '@/GoogleLoginResponse';
import LocalLoginRequest from './LocalLoginRequest';
import RecaptchaProtectedResponse from './RecaptchaProtectedResponse';

export class LoginServiceStatic {
    private loginAttemptPromise: Promise<void> | null = null

    checkSubscription(): Promise<AxiosResponse<SubscriptionValidResult>> {
        const url = `${process.env.VUE_APP_BASE_URL_API}/api/secure/user/checksubscription`
        return AxiosPostProcessor.postProcess(Axios.get<SubscriptionValidResult>(url, AxiosDefaultRequestConfig.merge({ })));
    }

    googleLogin(code: string): Promise<AxiosResponse<GoogleLoginResponse>> {
        const url = `${process.env.VUE_APP_BASE_URL_API}/api/googlelogin${QueryStringUtility.getQueryString({code})}`
        return AxiosPostProcessor.postProcess(Axios.get<GoogleLoginResponse>(url, AxiosDefaultRequestConfig.merge({ })));
    }

    loginGet(): Promise<AxiosResponse<User>> {
        const url = `${process.env.VUE_APP_BASE_URL_API}/api/login`
        return AxiosPostProcessor.postProcess(Axios.get<User>(url, AxiosDefaultRequestConfig.merge({ })));
    }

    ensureLoginAttempted(store: any): Promise<void> {
        if(store.getters.loginAttempted || store.getters.isUserLoggedIn) {
            return Promise.resolve()
        }

        if(this.loginAttemptPromise === null) {
            this.loginAttemptPromise = this.loginGet()
                .then(async response => {
                    if(response.data !== null) {
                        await store.commit('login', response.data)
                    }
                })
                .catch(error => {
                    console.warn(error)
                })
                .finally(() => {
                    store.commit('loginAttempted')
                    this.loginAttemptPromise = null
                })
        }

        return this.loginAttemptPromise
    }

    loginPostUrl() { return `${process.env.VUE_APP_BASE_URL_API}/api/login`; }

    loginLocal(model: LocalLoginRequest): Promise<AxiosResponse<RecaptchaProtectedResponse>> {
        const url = `${process.env.VUE_APP_BASE_URL_API}/api/loginlocal`
        return AxiosPostProcessor.postProcess(Axios.post<RecaptchaProtectedResponse>(url, model, AxiosDefaultRequestConfig.merge({ })));
    }

    removeSubscriptionInfo(): Promise<AxiosResponse> {
        const url = `${process.env.VUE_APP_BASE_URL_API}/api/secure/user/removesubscriptioninfo`
        return AxiosPostProcessor.postProcess(Axios.get(url, AxiosDefaultRequestConfig.merge({ })));
    }
}
const LoginService = new LoginServiceStatic();
export default LoginService;
